class TrapFocus {
  constructor(options = {}) {
    let defaultOptions = {
      focusableElements: 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])',
      ele: '',
      activeClass: ''
    };

    this.options = { ...defaultOptions, ...options };
    this.init();
  }

  init() {
    this.bindListeners();
  }

  bindListeners() {
    const _this = this;
    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
  }

  keydownEventListener(e) {
    const _this = this;
    let isActive = this.options.ele.classList.contains(this.options.activeClass);

    if (!isActive)
      return;

    switch (e.key) {
      case 'Tab':
        _this.trapFocus(e);
        break;
    }
  }

  trapFocus(e) {
    const _this = this;
    const focusableContent = this.options.ele.querySelectorAll(_this.options.focusableElements);
    const firstFocusableElement = focusableContent[0];
    const lastFocusableElement = focusableContent[focusableContent.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  }
}
